import { RequestSolicitationsService } from '../../../services/solicitations/request-solicitations.service';
import { Observable, from } from 'rxjs';
import { IDataTypeData } from './../../Common/IDataTypeData';
import { EventEmitter, Injectable } from "@angular/core";
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/es-CO'

registerLocaleData(localeFr, 'es');

export enum StatusClient {
  "actualizado" = "0",
  "proximo_a_desactualizar" = "1",
  "desactualizado" = "2",
}

export interface IBasicData {
  client_id?: number | string,
  document_type_desc?: number | string,
  document_type?: number | string,
  document_number?: number,
  client_names?: string,
  client_surnames?: string,
  state?: number,
  city?: number,
  address?: string,
  economic_activity?: number,
  segment?: number | string,
  subsegment?: number | string,
  gender?: string,
  customer_exists: boolean,
  customer_loaded: boolean,
  customer_error: boolean,
  chktycmodal?: boolean,
  originator_branch?: string,
  isNaturalPerson?: boolean,
  customer_validation?: boolean,
  exists_data?: any
}


export interface IContactsData {
  CA_Names: string | any,
  CA_LastName: string | any,
  CA_Phone: string,
  CA_Email: string,
  CA_CodeProduct: string,
  SA_Names: string,
  SA_LastName: string,
  SA_Phone: string,
  SA_Email: string,
  contact_primary: IContact,
  contact_additional: IContact
  advisor_visible?: boolean
}

export interface IRequestSolicitationRequest {
  data: {
    solicitation?: {  
      document: {
        typeId: string,
        type: string | number,
        number: string | number,
        id?: string | number,
        user_type: string, // ->TT
        nit?: string | number,
        type_code?: string // "document.type" -> 3
      },
      complain: {
        channel_id: string | number,
        channel_name: string,
        complain_id?: string,
        created_date?: string,
        complain_desc: string,
        complain_form: string, //Siempre enviar en vacio para escribir a la bd de sqr
        complain_express?: string
      },
      user: {
        name: string,
        first_name: string,
        given_name?: string,
        first_surname: string,
        second_surname?: string,
        user_type: string,//"Natural" "Juridico",
        user_id?: string | number, //"1" ->Nat "2" -> Jur
        age?: string,
        email: string,
        segment: {
          segment_id: string, //-> 0
          segment_name: string,
        },
        sub_segment: {
          sub_segment_id: string, //-> 0
          sub_segment_name: string,
        }
      },
      phones: Array<{
        phone_type: string, //Phone1, Phone2,
        phone_number: string
      }>,
      address: {
        street: string, // Dirección
        district_code: string,
        city_code: string,
        country: string, //-> "COL"
        portal_code: string
      },
      legal_person?: string, //-> Razon social -> opcional
      contacts: Array<{
        email: string,
        phones: Array<{ phone_number: string }>,
        user_name: string
      }>,
      solicitation_originator: string,//"Otra",
      admission: string,//"Queja o reclamo admitida por el DCF",
      acceptance: string,//"Respuesta final a favor del consumidor financiero aceptadas por la entidad",
      correction: string,//"Respuesta final a favor del consumidor financiero aceptadas por la entidad",
      solicitation_reason?: string,
      relation_control_entity: string,//"Si",
      control_entity: string,//"99",
      control_entity_id?: string,
      control_area?: string,
      time_solution?: string,
      expiration_date?: string,
      guardianship_flag?: boolean,
      escalation_flag?: boolean,
      withdrawal_flag?: boolean,
      replica_flag?: boolean,
      solicitation_argument: string, //"No",
      new_contacts_flag: boolean,
      solicitation: string, //-> Constante "Prueba radicación"
      solicitation_description?: string, //validar obligatoriedad
      solicitation_category: string, //-> tipo_solicitud -> paso 3
      solicitation_category_name: string,
      solicitations: Array<{
        solicitation_subtype: string, //-> subtipo_solicitud -> paso 3
        solicitation_subtype_name: string,
        origin_amount: {
          amount: string, //-> Solicitation_value -> paso 3 -> replace (.) por vacio
          currency: string, //-> COP
          decimals: string // -> 2
        }
      }>,
      solicitation_activity?: string, //-> obligatorio validar
      branch_id?: string, //-> celula temporal -> validar
      employee?: {
        employee_product_name?: string,
        phone_product_num?: {
          phone?: string
        },
        email_product_addr?: string,
        employee_name?: string,
        phone_num?: { phone?: string },
        email_addr?: string,
        user_name?: string,
        business?: string, //-> no esta definido -> validar
        product?: string  //-> no esta definido -> validar
      },
      product?: {
        product_name?: string, //-> no esta definido -> validar
        product_id?: string, //-> no esta definido -> validar
        product_client_id?: string
      },
      gender: string,// "No aplica",
      gender_id: string, //"10",
      gender_flag?: boolean, //false,
      special_condition: string,// "No aplica",
      special_condition_id: string,//"98",
      email_flag?: boolean, //false,
      phone_flag?: boolean, //false,
      person_flag?: boolean, //false,
      additional_information?: string,
      solicitation_cell: string,
      solicitation_cell_name: string,
      solicitation_application: string,
      binding_date?: string,
      last_update_date?: string,
      risk_last_update_date?: string,
      max_update_date?: string,
      client_status_flag: string,
      risk_level_id: string,
      business_relationship?: string,
      product_relationship?: string 
    },
    solicitation_encrypt?: string,
    crypto_vault?: {
      fields?: Array<string>,
      headers?: Array<string>
    },   
  }
}

export interface IRequestSolicitationResponse {
  data: {
    solicitation?: {
      solicitation_id: string,
      solicitation_code: string,
      transaction_code: string,
      reference_id: string,
      solicitation_id_code: string
    }
  }
}

export interface IRequestSolicitationErrorResponse {
  code: string,
  message: string,
  numberTrys: number
}

export interface IFindSolicitationResponse {
  data: Array<IFindSolicitationResponseObject>
}

export interface IFindSolicitationResponseObject {
  close_dt: string,
  document_number: string,
  document_type: string,
  exp_dt: string,
  solicitation_close_category: string,
  solicitation_close_desc: string,
  solicitation_desc: string,
  solicitation_id: string,
  solicitation_status_desc: string,
  trn_dt: string

}

export interface IFindSolicitationErrorResponse {
  code: string,
  message: string
}

export interface ISolicitation {
  /**
  * @todo Ajustar modelo segun servicios -- Guardado temporal en memoria
  */
  basicData?: IBasicData;
  contactsData?: IContactsData;
  additionalData?: IAdditionalData;
  risknvlData?: IRiskNvlData;
  analyticsData?: IAnalyticsData;
}
export interface IContact {
  id?: string | number,
  names: string,
  surnames: string,
  phone_1: string,
  email: string,
  contact_exist: boolean
}

export interface IAdditionalData {
  SolicitationValue?: number,
  CustomerTypes: string,
  SolicitationType: string,
  SolicitationSubtype: string,
  Annotations?: string,
  Cell: { id: string, name: string },
  additional_data?: Array<{ file: File, }>,
  transfers?: [],
  numberTrys?: number,
  errorUpload?: boolean
}

export interface IRiskNvlData {
  client_status: StatusClient,
  last_update_date: string,
  last_update_risk_date: string,
  risk_level_category: string,
  risk_level_code: string,
  start_date: string,
  update_maximun_date: string,
  annotations_error?: string
}

export interface IAnalyticsData {
  document_type: string,
  solicitation_type: string,
  solicitation_subtype: string,
  solicitation_cell: string,
  customer_type: string
}

@Injectable()
export class SolicitationsDataSource {
  x: number = 0;
  modalAShow = false;
  modalBShow = false;
  public deleteItem: EventEmitter<any> = new EventEmitter<number>(true);
  public update: EventEmitter<any> = new EventEmitter<any>();
  public solicitations: IDataTypeData[] = [];
  _isObservable: Observable<any> = new Observable(() => { });
  public dataLength: number = this.solicitations.length;
  public pageIndex: number = 0;
  public pageSize: number = 2;
  public previousPageIndex: number = 0;
  public init: number = 0;
  public position: number = 0;
  public curPag: number = 2;
  public items: any = {};
  public dataitem: IDataTypeData | any;
  fileCountOK = true;
  public pageSizeOptions = [1, 2, 5, 10];
  //{key:"",value:""}
  displayedColumnsList: string[] = ['NumeroRadicado', 'EstadoActual', 'FechaRadicacion', 'TipoSolicitud', 'Observaciones'];
  displayedColumns: [] | any = [
    { key: "NumeroRadicado", value: "Número radicado", sort: true, format: '' },
    { key: "EstadoActual", value: "Estado actual", sort: true, format: '' },
    { key: "FechaRadicacion", value: "Fecha de radicación", sort: true, format: '' },
    { key: "TipoSolicitud", value: "Tipo de solicitud", sort: true, format: '' },
    { key: "Observaciones", value: "Observaciones adicionales", sort: false, format: '' },
  ];
  tipoClientes = [
    { id: "1", desc: "PERSONA JURIDICA" },
    { id: "2", desc: "PERSONA NATURAL" }
  ];
  constructor() {
    this.getSolicitations();
    this.onPageChange({ length: this.dataLength, pageIndex: 0, pageSize: this.pageSize, previousPageIndex: 0 });
  }

  public getSolicitations(): Observable<IDataTypeData[]> {
    from([this.solicitations]).subscribe((t: any) => {
      this.items = t;
    });
    return this.items;
  }

  public deleteSolicitation(idx: number = 0): Observable<IDataTypeData[]> {
    this.solicitations = this.solicitations.filter((x: any) => x.id != idx);
    this.items = this.items.filter((x: any) => x.id != idx);
    this.dataLength = this.solicitations.length;
    return from([this.items]);
  }

  public tableSieve(_args: any) {
    let args = _args.event;
    let type = _args.type;
    let k = _args.event.columnName;
    let dir = _args.dir ?? '';
    switch (type) {
      case ('Change'): {
        let _this = Array.from(this.solicitations);
        this.items = _this.splice(this.position, this.pageSize);
        break;
      }
      case ('Sort'): {
        let _this = this.items.sort((t: any, x: any) => {
          if (dir == 'asc') {
            return t[k] > x[k] ? 1 : -1;
          }
          else {
            return t[k] < x[k] ? 1 : -1;
          }
        });
        this.items = _this;
        break;
      }
      case ('Data'): {
        break;
      }
      default: { break; }
    }
    this.items.push({ id: 0, NumeroRadicado: 0, EstadoActual: '', FechaRadicacion: '', TipoSolicitud: '', SubtipoSolicitud: '', CelulaAsignada: '', Valor: '' });
    this.items = this.items.filter((x: IDataTypeData) => x.id != 0);
  }

  public onPageChange($event: any): Observable<IDataTypeData[]> {
    this.pageSize = $event.pageSize;
    this.pageIndex = $event.pageIndex;
    this.previousPageIndex = $event.previousPageIndex;
    let cur = this.position + this.pageSize >= this.dataLength ? this.position - this.pageSize : this.position + this.pageSize;
    this.position = $event.pageIndex == 0 ? 0 : cur;
    this.tableSieve({ type: 'Change', event: $event });
    return from([this.solicitations]);
  }

  async modal(name: string, element: any = null) {
    this.modalAShow = name == 'A';
    this.modalBShow = name == 'B';
    this.dataitem = {};
    if (Object.values(element).length > 2) Object.assign(this.dataitem, element)
    if (Object.values(element).length == 0) this.x = element;
  }

  processItem(type: any) {
    if (this.modalAShow) {

    }
    if (this.modalBShow && type == "action2") {
      this.deleteSolicitation(this.x);
    }
  }
  async close(event: any, id: any = undefined) {
    let emmtr = event.hasOwnProperty('type') ? event.type : event.type;
    this.processItem(emmtr);
    this.modalAShow = false;
    this.modalBShow = false;
  }
  async sortData($event: any, key?: string) {
    await this.tableSieve({ type: 'Sort', event: $event, dir: $event.direction == 'asc' ? $event.direction : 'desc' });
  }
}
